<template>
    <div class="postListItem">
        <div class="card">

            <div class="card-body">

                <div class="title">
                    <div class="row">
                        <div class="col-9 longpoint"  :title="post.post.title">
                            <portal-logo :post="post" mh="20px" /> {{post.post.title}}
                        </div>
                        <div class="col-3 text-right">
                            {{post.post.duration | time}}
                        </div>
                    </div>
                </div>

                <div class="holder" @click="playVideo" :style="{'background-image': bgImage }"></div>

                <div class="options">
                    <div class="row">
                        <div class="col-8 longpoint">
                            <a :href="getBlogUrl(post.blog)" @click.prevent="showBlog(post.blog)"> <blog-avatar :blog="post.blog" :w="20" :h="20"/> {{post.blog.title}}</a>
                        </div>
                        <div class="col-4 text-right btns-right">
                            <a v-if="isAdmin" href="#" @click.prevent="deletePost()"><icon icon="trash-alt"/></a>
                            <a href="#" @click.prevent="showPostInfo"><icon icon="comment"/></a>
                            <share-btn :post="post"/>
                            <like-post-button :post="post"/>
                            <reblog-btn :post="post" />
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>

    import PortalLogo from '../ui/PortalLogo.vue';
    import BlogAvatar from "../ui/BlogAvatar.vue";
    import Icon from "../ui/Icon";
    import ReblogBtn from '../ui/buttons/ReblogButton.vue';
    import ShareBtn from '../ui/buttons/SharePostButton';
    import LikePostButton from "../ui/buttons/LikePostButton";

    export default {
        name: 'PostListItem',
        props: ['post'],
        data() {
            return {}
        },
        computed:{
            bgImage(){
                return "url('"+this.post.post.preview+"')";
            },
            isAdmin(){
                let userId = this.$store.getters['user/id'];
                let found = this.post.blog.admins.find((item)=> userId == item );
                return (found) ? true : false;
            }
        },
        created() {
        },
        methods: {
            playVideo(){
                this.$bus.$emit('playVideo', this.post);
            },
            retweet(){
                this.$bus.$emit('postToBlog', {post: this.post});
            },
            deletePost(){
                this.$swal({
                    title: 'Delete this Post?',
                    text: 'This post will not be displayed on your blog anymore',
                    showCancelButton: true,
                    type: 'warning',
                    confirmButtonText: 'Yes, delete it!',
                    confirmButtonColor: '#d618e7'
                }).then(()=>{
                    this.$api.deletePost(this.post._id).then((res)=>{
                        this.$bus.$emit('post.deleted', this.post);
                    });
                });
            },
            getBlogUrl(blog){
                return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
            },
            showBlog(blog){
                if(this.$route.path != this.getBlogUrl(blog)){
                    this.$bus.$emit('blog-modal.open', {blog});
                }
            },
            showPostInfo(){
                this.$bus.$emit('postInspector.show', {post:this.post, theme: 'light'});
            }

        },
        components:{
            LikePostButton,
            Icon,
            BlogAvatar,
            PortalLogo,
            ReblogBtn,
            ShareBtn
        }

    }
</script>

<style lang="sass" scoped>

    @import "../../assets/sass/vars"

    .postListItem
        width: 100%
        padding: 10px
        float: left

        @media screen and (min-width: $grid-md)
            width: 50%

        @media screen and (min-width: $grid-lg)
            width: 33.333333%

        .card
            box-shadow: 0 2px 4px rgba(0,0,0,.6)
            position: relative
            overflow: hidden
            transition: background-color .2s ease-out
            border: 0

            .card-body
                padding: 0

            .holder
                padding-top: 46%
                position: relative
                overflow: hidden
                background-position: 50% 50%
                background-size: cover
                background-repeat: no-repeat
                cursor: pointer
                z-index: 1

            .title, .options
                padding: 4px 8px
                font-size: .9em
                color: #ccc
                background-color: #333

                a
                    color: #ccc
                    text-decoration: none

            .options
               .btns-right
                 padding-left: 0

        .card:hover .title,
        .card:hover .options
             background-color: #222



</style>



// WEBPACK FOOTER //
// src/components/posts/PostListItem.vue